import axios from 'axios';

import parseBlobError from '../utils/parseBlobError';
import storedToken from '../utils/session-data/api-token';

export default (baseURL, env) =>
  (method, url, data = {}, config = {}, skipError = false) => {
    const token = storedToken.get();

    /**
     * If we run into rejected API request logs in tests again, uncomment this to
     * get some indicator, which API functions are called, but not prepared
     */
    // if (process.env.NODE_ENV === 'test' && !token) {
    //   throw new Error('Missing token. Please mock the API in tests.')
    // }

    if (!baseURL) {
      return Promise.reject(new Error(`${env} not configured.`));
    }

    return axios({
      baseURL,
      method,
      url,
      data,
      headers: {
        Authorization: token && `Bearer ${token}`,
        Accept: 'application/json',
      },
      ...config,
    }).then(
      response => (config.responseType ? response : response.data), // For blobs, the file name is part of the response headers
      async error => {
        console.error(error); // eslint-disable-line no-console
        const newError = new Error(error.message);
        newError.response = error.response;
        newError.request = error.request;

        if (config.responseType) {
          newError.data = await parseBlobError(error);
        } else {
          newError.data = error.response && error.response.data; // Rewrap
        }
        if (skipError) return error;
        throw newError;
      },
    );
  };
